import { IonIcon, IonText } from '@ionic/react';
import { ReactNode, useCallback } from 'react';

import styles from '@components/text/TextWithIcon.module.css';
import { maybeWrapElementInHoverText } from '@utils/htmlUtils';
import { IconList, IconName } from '@utils/iconUtils';

type Props = {
  color?: string;
  hoverContent?: ReactNode;
  icon: IconName;
  iconFirst?: boolean;
  large?: boolean;
  text: string | ReactNode | undefined;
};

const TextWithIcon = ({ color, hoverContent, icon, iconFirst = false, large, text }: Props) => {
  const textStyle = large ? styles.textLarge : styles.text;
  const iconStyle = large ? styles.largeIcon : styles.icon;

  const renderIcon = useCallback(() => {
    const src = IconList[icon];
    return (
      <IonIcon
        aria-label={text as string}
        className={((icon === 'spinner' && styles.spinningIcon) || ' ') + ' ' + iconStyle}
        src={src}
      />
    );
  }, [icon, iconStyle, text]);

  if (iconFirst) {
    return maybeWrapElementInHoverText(
      hoverContent,
      <>
        <IonText className={styles.marginRight} color={color}>
          {renderIcon()}
        </IonText>
        <span className={textStyle}>
          <IonText color={color}>{text}</IonText>
        </span>
      </>
    );
  }

  return maybeWrapElementInHoverText(
    hoverContent,
    <>
      <span className={textStyle + ' ' + styles.marginRight}>
        <IonText color={color}>{text}</IonText>
      </span>
      <IonText color={color}>{renderIcon()}</IonText>
    </>
  );
};

export default TextWithIcon;
